import './style.scss'
import { useContext } from "react"
import { AbsoluteContainer, AppSpan, Circle, CustomContainer, FixedContainer, FlexRow, GridContainer, MenuIcon, ScreenTitle } from "src/style"
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import { BsBell } from "react-icons/bs";
import { VscMenu } from 'react-icons/vsc'
import Logo from 'src/assets/svg/logo.svg'


export const Header = () => {
    const {visibility, showSideBar} = useContext(VisibilityContext)

    return (
        <>
            <MenuIcon onClick={() => showSideBar(!visibility.isSideBar)} >
                <VscMenu/>
            </MenuIcon>
            <FixedContainer 
                width="100" 
                sizeUnit="%" 
                zIndex="2" 
                top='0' 
                left='0'
                leftPadding='30'
                className='header-container'
            >
                <FlexRow 
                    height='7.5'
                    padding='2.5'
                    justifyContent='space-between'
                >
                     <AppSpan></AppSpan>
                    <FlexRow 
                        gap='1'
                        width='auto' sizeUnit=''
                        className='header-logo-container'
                    >
                        <GridContainer 
                            width='3.7' 
                            height='3.7' 
                            radius='0.4' 
                            bgColor='#333333'
                        >
                            <img src={Logo} className='img-child'/>
                        </GridContainer>
                        <AppSpan
                            textSize='1.6'
                            color='#333333'
                            fontWeight='700'
                        >
                            Humexid
                        </AppSpan>
                    </FlexRow>
                    <GridContainer 
                        width='4' 
                        height='4' 
                        borderColor='#E0E0E0' 
                        radius='0.4'
                    >
                        <BsBell fontSize='2rem' />
                        <AbsoluteContainer top='0.5' right='0.8'>
                            <Circle size='1' bgColor='#EB5757' />
                        </AbsoluteContainer>
                    </GridContainer>
                </FlexRow>
            </FixedContainer>
        </>
    )
}